import { html, unsafeCSS } from 'lit';
import { PopBaseComponent } from '../../../base/pop-base-component';
import { property } from 'lit/decorators.js';
import { Constants } from './morningstar-style-box-heading.constants.js';
import { dateShort } from '../../../common/utils/formatDate';

/**
 * Morningstar Style Box Heading Component
 * Render heading Morningstar Style Box™
 *
 * @element morningstar-style-box-heading
 *
 * @property {string} asOfDate - Date for data as of label
 * @property {string} assetClass - Asset class label for the subheading
 */
export class MorningstarStyleBoxHeading extends PopBaseComponent {
  static get is(): string {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return 'pop-morningstar-style-box-heading' as keyof HTMLElementTagNameMap;
  }

  static styles = [unsafeCSS(super.styles)];

  @property({ type: String })
  asOfDate: string | null = null;

  @property({ type: String })
  assetClass: string | null = null;

  render() {
    return html`
      <div
        class="b-typography-serif--headline--100 b-margin-block-end--micro--normal"
      >
        ${Constants.HEADER_TEXT}
      </div>
      ${this.asOfDate
        ? html`
            <div
              class="b-typography-sans-serif--caption-loose--300 b-font-weight-light b-margin-block-end--micro--normal"
            >
              ${`${Constants.DATA_AS_OF} ${dateShort(this.asOfDate)}`}
            </div>
          `
        : ''}
      ${this.assetClass
        ? html`
            <div
              class="b-typography-sans-serif--body--100 b-font-weight-bold b-margin-block-end--micro--normal"
            >
              ${this.assetClass}
            </div>
          `
        : ''}
    `;
  }
}

customElements.define(
  MorningstarStyleBoxHeading.is,
  MorningstarStyleBoxHeading,
);
